import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import App from './App.tsx';
import { IframeAuthProvider } from './src/contexts/IframeAuthProvider.tsx';
import './src/styles/globals.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Configuration from environment variables
const authDomain = import.meta.env.VITE_AUTH_DOMAIN || 'https://auth.staging.darwingov.com';
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:7773';
const darwinLoginUrl = import.meta.env.VITE_DARWIN_LOGIN_URL || 'https://login.darwingov.com';

const handleNavigateToLogin = () => {
  window.location.href = `${darwinLoginUrl}?redirect_uri=${encodeURIComponent(window.location.origin)}`;
};

const getQueryParam = (param: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <IframeAuthProvider
          authDomain={authDomain}
          apiBaseUrl={apiBaseUrl}
          darwinLoginUrl={darwinLoginUrl}
          onNavigateToLogin={handleNavigateToLogin}
          getQueryParam={getQueryParam}
        >
          <App />
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#4ade80',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
        </IframeAuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);